import { mdiDeleteForever, mdiFileEdit } from "@mdi/js";
import {
  OptGrid,
  OptGridColumn,
  OptGridOptions,
  OptGridRef,
  OptGridRequest,
  OptGridResponse,
} from "@optsol/react";
import React from "react";
import { Colors } from "../../../compartilhado/colors";
import { OptGridContainer } from "../../../componentes/OptGridContainer";
import { CategoriaSearchResponse } from "../../../modelos/dtos/CategoriaSearchResponse";

interface Props {
  onRowClick: (rowData?: CategoriaSearchResponse) => void;
  carregar: (
    data: OptGridRequest
  ) => Promise<OptGridResponse<CategoriaSearchResponse>>;
  onClickDelete: (rowData: CategoriaSearchResponse) => void;
  onClickEdit: (rowData: CategoriaSearchResponse) => void;
  gridRef: React.MutableRefObject<OptGridRef | null>;
}

const options: OptGridOptions = {
  search: true,
  pageSize: 10,
};

export const GridCategoriasView = React.forwardRef<OptGridRef | undefined, Props>(
  (
    {
      carregar,
      onRowClick,
      onClickDelete,
      onClickEdit,
      gridRef,
    },
    ref
  ) => {
    const columns: OptGridColumn<CategoriaSearchResponse>[] = [
        {
            title: "Id",
            field: "id",
            hidden: true,
        },
        {
        title: "Nome",
        field: "nome",
        align: "left",
        hidden: false,
        width: 15,
      },
      {
        title: "Descrição",
        field: "descricao",
        align: "left",
        hidden: false,
        width: 300,
      },
    ];

    return (
      <>
        <OptGridContainer>
          <OptGrid
            title=""
            ref={gridRef}
            columns={columns}
            data={carregar}
            options={options}
            onRowClick={onRowClick}
            actionsPosition={"end"}
            actions={[
              (rowData) => ({
                icon: {
                  path: mdiFileEdit,
                  size: 1,
                  color: Colors.gray,
                },
                tooltip: "Editar categoria",
                onClick: () => onClickEdit(rowData),
                disabled: false,
              }),
              (rowData) => ({
                icon: {
                  path: mdiDeleteForever,
                  size: 1,
                  color: Colors.red2,
                },
                tooltip: "Exluir categoria",
                onClick: () => onClickDelete(rowData),
                disabled: false,
              })
            ]}
          />
        </OptGridContainer>
      </>
    );
  }
);
